import './code-editor.css';
export default {
  "codeEditor": "pf-v6-c-code-editor",
  "codeEditorCode": "pf-v6-c-code-editor__code",
  "codeEditorCodePre": "pf-v6-c-code-editor__code-pre",
  "codeEditorContainer": "pf-v6-c-code-editor__container",
  "codeEditorControls": "pf-v6-c-code-editor__controls",
  "codeEditorHeader": "pf-v6-c-code-editor__header",
  "codeEditorHeaderContent": "pf-v6-c-code-editor__header-content",
  "codeEditorHeaderMain": "pf-v6-c-code-editor__header-main",
  "codeEditorMain": "pf-v6-c-code-editor__main",
  "codeEditorTab": "pf-v6-c-code-editor__tab",
  "codeEditorTabIcon": "pf-v6-c-code-editor__tab-icon",
  "codeEditorTabText": "pf-v6-c-code-editor__tab-text",
  "codeEditorUpload": "pf-v6-c-code-editor__upload",
  "labelName": "label-name",
  "modifiers": {
    "readOnly": "pf-m-read-only",
    "fullHeight": "pf-m-full-height",
    "plain": "pf-m-plain",
    "dragHover": "pf-m-drag-hover"
  },
  "monacoEditor": "monaco-editor"
};